import { ComponentProps } from 'react';

import Alert from '@/components/Alert';
import Text from '@/components/Text';
import { useRoomOptionsData } from '@/v2/components/pages/PackageViewV2/contexts/RoomOptionsContext';
import { useCampaign } from '@/v2/contexts/campaign';

const CampaignAppliedNotification = (
  props: ComponentProps<typeof Alert.Success>,
) => {
  const campaign = useCampaign();
  const promoCode = campaign?.sashing?.flightPromoCode;
  const title = campaign?.sashing?.flightPillText;
  const { isLoading, lastSearchCausedSwitchToCampaignOptions } =
    useRoomOptionsData() || {};

  const showCampaignApplied =
    !isLoading && title && promoCode && lastSearchCausedSwitchToCampaignOptions;

  return showCampaignApplied ? (
    <Alert.Success {...props}>
      <Text mb="0" lineHeight="1.25rem" bold fontSize="xs">
        We’ve found you a {title} Deal
      </Text>
    </Alert.Success>
  ) : null;
};

export default CampaignAppliedNotification;
